import { render, staticRenderFns } from "./ProjectResult.vue?vue&type=template&id=2b023487&"
import script from "./ProjectResult.vue?vue&type=script&lang=js&"
export * from "./ProjectResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports